import { createSelector } from "@reduxjs/toolkit";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";
import { selectedVariations } from "@src/store/slices/variations";

export const isSelectedVariationControl = createSelector(
  experienceBuilderSlice.selectors.getVariationId,
  selectedVariations,
  (variationId, variations) => {
    const selectedVariation = variations.find((v) => v.id === variationId);
    return selectedVariation?.isControl ?? false;
  }
);
